module.exports = __webpack_public_path__ + "static/exercise-img-6-75095959b2d70b7640c8e71fedbf1afd.png";